/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Sports10Inputs */

const en__field_enum_tuda_sports10 = /** @type {(inputs: _Field_Enum_Tuda_Sports10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports & Fitness`)
};

const de__field_enum_tuda_sports10 = /** @type {(inputs: _Field_Enum_Tuda_Sports10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport & Fitness`)
};

/**
* | output |
* | --- |
* | "Sports & Fitness" |
*
* @param {_Field_Enum_Tuda_Sports10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_sports10 = /** @type {((inputs?: _Field_Enum_Tuda_Sports10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Sports10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_sports10(inputs)
	return de__field_enum_tuda_sports10(inputs)
});
export { _field_enum_tuda_sports10 as "_field_enum_TUDA_SPORTS" }